import React from "react"
import { Box, Progress } from "@carrotfertility/carotene-core"
import { PageLayout } from "./page-layout"

// Loading state for routes that render into the default page shell. Keeps the
// spinner inside the same layout the loaded page uses, avoiding a full-viewport
// flash and a layout jump when data arrives.
export function PageLoading(): JSX.Element {
  return (
    <PageLayout variant="default">
      <Box sx={{ blockSize: "50vb", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Progress />
      </Box>
    </PageLayout>
  )
}
